module.exports = __webpack_public_path__ + "img/Yipi_AnimacionWeb_08_Ipad.667cd830.gif";